import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';

import { COMMON_STANDALONE_IMPORTS } from '@shared/common-imports';
import { FormErrorComponent } from '@shared/components';
import { RequiredLabelDirective } from '@shared/directives';
import { FormGroupOf, ResetPasswordRequest } from '@shared/models';
import { AuthHttpService, ToastsService } from '@shared/services';
import { FormGenerator, FormGroupExtension } from '@shared/utils';

import { AuthCardComponent } from '../auth-card/auth-card.component';

@Component({
  templateUrl: './reset-password.component.html',
  imports: [
    ...COMMON_STANDALONE_IMPORTS,
    TranslateModule,
    FormErrorComponent,
    PasswordModule,
    ButtonModule,
    RequiredLabelDirective,
    AuthCardComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordComponentLoader = 'resetPasswordComponentLoader';

  editForm: FormGroup<FormGroupOf<ResetPasswordRequest>> = FormGenerator.initResetPasswordForm(this.translate);

  constructor(
    private authService: AuthHttpService,
    public toastsService: ToastsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token');
    const email = this.activatedRoute.snapshot.queryParamMap.get('email');
    this.editForm = FormGenerator.initResetPasswordForm(this.translate, new ResetPasswordRequest(email, null, token));
  }

  onSubmit(): void {
    if (FormGroupExtension.hasAnyValidationError(this.editForm)) {
      FormGroupExtension.markFormAsDirtyAndTouched(this.editForm);
      this.translate.instant('error.invalidForm');
      return;
    }
    this.authService.resetPassword(this.resetPasswordComponentLoader, this.editForm.getRawValue()).subscribe({
      next: () => {
        this.toastsService.showSuccess(this.translate.instant('auth.forgotPassword.newPasswordSavedToast'));
        this.router.navigate(['auth', 'login']);
      },
      error: (error) => this.toastsService.showError(error),
    });
  }
}
